import { Link } from 'react-router-dom';
import { allCategories, allTags } from '@/utils/news';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 bg-primary-950 text-background-200">
      <div className="mx-auto max-w-page px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="mb-4 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-lg text-background-50 dark:text-foreground-950">
                <i className="ri-fire-fill"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">热搜榜</span>
            </div>
            <p className="text-sm leading-relaxed text-background-300">
              热搜榜是聚焦实时热门话题与趋势资讯的平台，覆盖社会、娱乐、科技等领域，帮你快速掌握当前热点。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {[
                { icon: 'ri-weibo-fill', label: '微博' },
                { icon: 'ri-wechat-fill', label: '微信' },
                { icon: 'ri-tiktok-fill', label: '抖音' },
                { icon: 'ri-bilibili-fill', label: '哔哩哔哩' },
              ].map((item) => (
                <span
                  key={item.label}
                  title={`${item.label}（演示）`}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-primary-800 text-base text-background-100 transition-colors hover:bg-accent-500 hover:text-background-50"
                >
                  <i className={item.icon}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-base font-bold text-background-50">
              <Link to="/" className="transition-colors hover:text-accent-400">
                资讯分类
              </Link>
            </h4>
            <ul className="flex flex-col gap-3 text-sm text-background-300">
              {allCategories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="transition-colors hover:text-accent-400">
                    {cat.name}热点
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-base font-bold text-background-50">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              {allTags.slice(0, 8).map((tag) => (
                <Link
                  key={tag.name}
                  to={`/category/${allCategories[0].slug}?tag=${encodeURIComponent(tag.name)}`}
                  className="rounded-full bg-primary-800 px-3 py-1 text-xs text-background-200 transition-colors hover:bg-accent-500 hover:text-background-50"
                >
                  {tag.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-base font-bold text-background-50">联系我们</h4>
            <ul className="flex flex-col gap-3 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-accent-400"></i>
                contact@hotsearch.demo
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-base text-accent-400"></i>
                010-8888-6666（示例）
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-base text-accent-400"></i>
                北京市朝阳区资讯大厦 8 层
              </li>
              <li>
                <Link to="/about" className="text-background-200 transition-colors hover:text-accent-400">
                  关于我们 →
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-primary-800 pt-6">
          <div className="flex flex-col gap-3 text-xs text-background-400 sm:flex-row sm:items-start sm:justify-between">
            <p>© {year} 热搜榜 HotSearch · 本站内容均为前端演示数据，不构成任何真实报道或信息发布。</p>
            <p className="sm:text-right">免责声明：演示站所展示的资讯、数据与人物均为虚构样例，仅供产品演示与测试使用。</p>
          </div>
        </div>
      </div>
    </footer>
  );
}